import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    providerCalendar: graphql(`
        fragment isBaseProviderCalendar_ProviderCalendar on ProviderCalendar {
            id
            temporalClasses {
                code
            }
        }
    `),
}

type IsBaseProviderCalendarProps = {
    providerCalendar: FragmentOf<typeof graphQLFragments.providerCalendar>
}

// The id check is on top of the temporal classes one because a base calendar is not
// guaranteed to have a single temporal class: a seasonal base calendar
// could have several temporal classes (one per season) while still being priced as base
export function isBaseProviderCalendar(props: IsBaseProviderCalendarProps) {
    const { id, temporalClasses } = readFragment(
        graphQLFragments.providerCalendar,
        props.providerCalendar
    )

    return (!!temporalClasses && temporalClasses.length <= 1) || /base/i.test(id)
}

isBaseProviderCalendar.fragments = graphQLFragments
